export default __webpack_public_path__ + "static/media/amber.9603632e.png";